"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valmozzola": {
    "a041d2bb": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "branzone": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f42d86da": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "mariano": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "53e96c74": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "mormorola": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "938b0eb8": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-di-gusaliggio": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2adfdb4a": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fdac1f99": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "skipSearch": false
    }],
    "valmozzola-stazione": [{
      "hkey": "7caf6978",
      "slug": "valmozzola",
      "name": "Valmozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;